import { useEffect } from 'react'
import { useNavigate } from 'react-router'
import authProvider from '../../core/AuthenticationProvider'
import EventEmitter, { SHOW_LOADING_SCREEN } from '../helpers/EventEmitter'
import { COMPONENTS } from '../routers/constants'
import { localStorageKeys } from '../utils/common'

const SignInCallBack = () => {
  const navigate = useNavigate()

  useEffect(() => {
    authProvider
      .signinCallback()
      .then(async () => {
        const user = await authProvider.getUser()
        EventEmitter.dispatch(SHOW_LOADING_SCREEN, true)
        if (user && !user?.profile?.user_id) {
          return authProvider.signout()
        }

        const returnUrl = localStorage.getItem(localStorageKeys.RETURN_URL)
        if (returnUrl) {
          navigate(returnUrl)
          localStorage.removeItem(localStorageKeys.RETURN_URL)
        } else if (localStorage.getItem(localStorageKeys.KEY_LOGOUT)) {
          navigate(COMPONENTS.dashboard.components.dashboard.route)
          localStorage.removeItem(localStorageKeys.KEY_LOGOUT)
        } else {
          navigate(COMPONENTS.dashboard.components.dashboard.route)
        }
      })
      .catch(() => {
        navigate(COMPONENTS.dashboard.components.dashboard.route)
      })
  }, [])

  return <></>
}

export default SignInCallBack
